import * as React from "react";
import Divider from "@mui/material/Divider";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import { useNavigate } from "react-router";
import { logout } from "../../Redux/authenticationSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  loginRoute,
  editProfile,
  changePassword,
  termsAndConditions,
  preferences,
} from "../../routes/reactRoutes";
import {
  AccountCircleOutlined,
  LogoutOutlined,
  PasswordOutlined,
  PrivacyTipOutlined,
  SettingsOutlined,
} from "@mui/icons-material";
import { logoutRoute } from "../../routes/apiRoutes";
import { send } from "../../Redux/deviceSlice";
import axiosInstance from "../../axios/axiosInstance";
import { t } from "i18next";
import { useTheme } from "@mui/material";

export default function ProfileMenu(props) {
  const theme = useTheme();
  // const currentUser = useSelector(
  //   (state) => state.authenticationValues.currentUser
  // );
  // const currentUserRoles = React.useMemo(
  //   () => currentUser.userRoles?.map((roleItem) => roleItem.role?.name) || [],
  //   [currentUser]
  // );
  // const isClient = React.useMemo(
  //   () => currentUserRoles.includes("Client"),
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [currentUserRoles, currentUser]
  // );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const deviceId = useSelector((state) => state.deviceValues.deviceId);
  const handleLogout = async () => {
    try{
    await axiosInstance.post(
      `${logoutRoute}`,
      { deviceId },
      { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
    );
    dispatch(logout());
   
    props.setOpen(false);
    navigate(loginRoute);
  } catch (error) {
    dispatch(logout());
    props.setOpen(false);
    navigate(loginRoute);
  }
  };  
  const handleEditProfile = () => {
    props.setOpen(false);
    navigate(editProfile);
  };
  const handleChangePassword = () => {
    props.setOpen(false);
    navigate(changePassword);
  };
  const handleTermsAndConditions = () => {
    props.setOpen(false);
    navigate(termsAndConditions);
  };
  const handlePreferences = () => {
    props.setOpen(false);
    navigate(preferences);
  };
  // const handleLanguageChange = (lang) => {
  //   props.setOpen(false);
  //   dispatch(changingDirection({ value: true }));
  //   setTimeout(() => {
  //     i18n.changeLanguage(lang);
  //     dispatch(setDirection({ directionValue: lang === "ar" ? "rtl" : "ltr" }));
  //     dispatch(changingDirection({ value: false }));
  //   }, 500);
  // };
  return (
    <MenuList style={{ direction: theme.direction }}>
      <MenuItem onClick={handleEditProfile}>
        <ListItemIcon>
          <AccountCircleOutlined color="primary" fontSize="small" />
        </ListItemIcon>
        <ListItemText>{t("editprofile")}</ListItemText>
      </MenuItem>
      <MenuItem onClick={handleChangePassword}>
        <ListItemIcon>
          <PasswordOutlined color="primary" fontSize="small" />
        </ListItemIcon>
        <ListItemText>{t("changepassword")}</ListItemText>
      </MenuItem>
      <MenuItem onClick={handleTermsAndConditions}>
        <ListItemIcon>
          <PrivacyTipOutlined color="primary" fontSize="small" />
        </ListItemIcon>
        <ListItemText>Terms and Conditions</ListItemText>
      </MenuItem>
      <MenuItem onClick={handlePreferences}>
        <ListItemIcon>
          <SettingsOutlined color="primary" fontSize="small" />
        </ListItemIcon>
        <ListItemText>Preferences</ListItemText>
      </MenuItem>
      {/* {isClient && (
        <MenuItem onClick={handleGoToPayment}>
          <ListItemIcon>
            <PaidOutlined color="primary"></PaidOutlined>
          </ListItemIcon>
          <ListItemText>{t("subscription")}</ListItemText>
        </MenuItem>
      )}
      <MenuItem
        onClick={() =>
          handleLanguageChange(i18n.language.startsWith("en") ? "ar" : "en")
        }
      >
        <ListItemIcon>
          <Language color="primary" fontSize="small" />
        </ListItemIcon>
        <ListItemText>
          {i18n.language.startsWith("en") ? "العربية" : "English"}
        </ListItemText>
      </MenuItem> */}
      <Divider />
      <MenuItem onClick={handleLogout}>
        <ListItemIcon>
          <LogoutOutlined color="primary" fontSize="small" />
        </ListItemIcon>
        <ListItemText>{t("logout")}</ListItemText>
      </MenuItem>
    </MenuList>
  );
}
